import { Link, navigate } from "@reach/router";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import Logo from "../../../assets/Logo.png";
import BackArrow from "assets/Icon_Back.png";
import PersonIcon from "assets/Icon_Field_01.png";
import BurgerIcon from "assets/Icon_Menu.png";
import AccountMenuDropdown from "../accountMenuDropdown/AccountMenuDropdown";
import LoggedInHeaderMessagesIcon from "./LoggedInMessagesIcon";
import useMedia from "use-media";
import {
  getUnreadMessages,
  parseGetUnreadMessageCount,
} from "./LoggedInNavBarApi";
import { selectIsNavBarShrunk, setIsNavBarShrunk } from "reducers/shrinkNavBar";
import { useDispatch, useSelector } from "react-redux";
import { selectAuthStatus } from "reducers/auth";

type LoggedInNavBarProps = {
  setMobileNavOpen: Dispatch<SetStateAction<boolean>>;
  mobileNavOpen: boolean;
};

const LoggedInNavBar: React.FC<LoggedInNavBarProps> = ({
  setMobileNavOpen,
  mobileNavOpen,
}) => {
  const isDesktop = useMedia("(min-width: 1200px)");
  const dispatch = useDispatch();
  const [showDropdown, setShowDropdown] = useState(false);
  const isNavBarShrunk = useSelector(selectIsNavBarShrunk);
  const authStatus = useSelector(selectAuthStatus);
  const handleDropdownShow = () => {
    setShowDropdown(true);
  };
  const handleDropdownHide = () => {
    setShowDropdown(false);
  };
  const handleAccountClick = () => {
    setShowDropdown(!showDropdown);
  };
  const [numberOfUnreadMessages, setNumberOfUnreadMessages] = useState("");

  useEffect(() => {
    let intervalId: NodeJS.Timeout;
    (async () => {
      if (authStatus === "signed_in") {
        const unreadMessages = await getUnreadMessages();
        setNumberOfUnreadMessages(
          parseGetUnreadMessageCount(unreadMessages).toString()
        );
      }
    })();
    intervalId = setInterval(() => {
      (async () => {
        const unreadMessages = await getUnreadMessages();
        setNumberOfUnreadMessages(
          parseGetUnreadMessageCount(unreadMessages).toString()
        );
      })();
    }, 90000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <div className="Header">
      <div
        className="Header__icon--burger"
        onClick={() => {
          if (isDesktop) {
            dispatch(setIsNavBarShrunk(!isNavBarShrunk));
          } else {
            setMobileNavOpen(true);
          }
        }}
      >
        <img src={BurgerIcon} className="BurgerIcon" alt="Open menu" />
      </div>
      <Link to="/sign-in">
        <img className="Header__logo" src={Logo} alt=""></img>
      </Link>
      <div className="LoggedInHeaderMessagesIcon__wrapper">
        <Link to="/messages">
          <LoggedInHeaderMessagesIcon unreadMessages={numberOfUnreadMessages} />
        </Link>
      </div>
      <div
        onMouseEnter={handleDropdownShow}
        onMouseLeave={handleDropdownHide}
        onClick={handleAccountClick}
        className={`AccountMenu  ${showDropdown ? "ShowAccount" : ""}`}
      >
        <div className="AccountMenu__Icon">
          <img src={PersonIcon} />
        </div>
        <span className="AccountMenu__Text">Account Settings</span>
        <div className="AccountMenu__Name"></div>
        <img className="AccountMenu__DropdownIcon" src={BackArrow} />
        <div
          className={`AccountMenu__DropdownMenu ${
            showDropdown ? "ShowAccount" : ""
          }`}
        >
          <AccountMenuDropdown />
        </div>
      </div>
    </div>
  );
};

export { LoggedInNavBar };
